import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "state",
    serviceName: "graphql",
    query: gql`
      query state($ids: [String]) {
        state(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
